export default __webpack_public_path__ + "e932e134aba94e352aeaffbfff11d8ff.svg";